import React, { useState } from 'react';
import { ArrowRight, Building2, TrendingUp, CheckCircle } from 'lucide-react';
import { caseStudies } from '../data/mock';

const CaseStudies = () => {
  const [activeCase, setActiveCase] = useState(0);

  return (
    <section id="case-studies" className="py-8 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-8">
          <span className="inline-block text-gold-600 font-semibold text-sm tracking-wider uppercase mb-4">
            Case Studies
          </span>
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-navy-900 mb-6">
            Success Stories
          </h2>
          <p className="text-base text-gray-600 leading-relaxed">
            Real results from businesses we've helped transform and revitalize
          </p>
        </div>

        {/* Case Studies Tabs */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {caseStudies.map((study, index) => (
            <button
              key={study.id}
              onClick={() => setActiveCase(index)}
              className={`px-6 py-3 rounded-full font-medium transition-all duration-300 ${
                activeCase === index
                  ? 'bg-navy-900 text-white shadow-lg'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              {study.title}
            </button>
          ))}
        </div>

        {/* Active Case Study */}
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="relative rounded-2xl overflow-hidden shadow-2xl">
            <img
              src={caseStudies[activeCase].image}
              alt={caseStudies[activeCase].title}
              className="w-full h-96 object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-navy-900/60 to-transparent" />
            <div className="absolute bottom-6 left-6">
              <span className="inline-block px-4 py-1.5 bg-gold-500 text-navy-900 rounded-full text-sm font-semibold">
                {caseStudies[activeCase].industry}
              </span>
            </div>
          </div>

          {/* Content */}
          <div className="space-y-8">
            <h3 className="text-2xl sm:text-3xl font-serif font-bold text-navy-900">
              {caseStudies[activeCase].title}
            </h3>

            <div className="space-y-6">
              {/* Challenge */}
              <div className="p-6 bg-red-50 rounded-xl border-l-4 border-red-400">
                <div className="flex items-center gap-2 text-red-700 font-semibold mb-2">
                  <Building2 className="w-5 h-5" />
                  The Challenge
                </div>
                <p className="text-gray-700">{caseStudies[activeCase].challenge}</p>
              </div>

              {/* Solution */}
              <div className="p-6 bg-blue-50 rounded-xl border-l-4 border-blue-400">
                <div className="flex items-center gap-2 text-blue-700 font-semibold mb-2">
                  <TrendingUp className="w-5 h-5" />
                  Our Solution
                </div>
                <p className="text-gray-700">{caseStudies[activeCase].solution}</p>
              </div>

              {/* Result */}
              <div className="p-6 bg-green-50 rounded-xl border-l-4 border-green-400">
                <div className="flex items-center gap-2 text-green-700 font-semibold mb-2">
                  <CheckCircle className="w-5 h-5" />
                  The Result
                </div>
                <p className="text-gray-700">{caseStudies[activeCase].result}</p>
              </div>
            </div>

            <a
              href="#contact"
              className="inline-flex items-center text-gold-600 font-semibold hover:text-gold-700 transition-colors"
            >
              Get Similar Results
              <ArrowRight className="ml-2 w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;
